// Formal Quote Module (CLAUDE.md) — multi-product price quotes, PDF export, push to customer
// price list.
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_URL}/api/quotes`;

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const quoteService = {
  getQuotes: () => axios.get(BASE, auth()).then(r => r.data),
  getQuote: (id) => axios.get(`${BASE}/${id}`, auth()).then(r => r.data),
  createQuote: (data) => axios.post(BASE, data, auth()).then(r => r.data),
  updateQuote: (id, data) => axios.put(`${BASE}/${id}`, data, auth()).then(r => r.data),
  deleteQuote: (id) => axios.delete(`${BASE}/${id}`, auth()).then(r => r.data),
  generatePdf: (id) => axios.post(`${BASE}/${id}/generate-pdf`, {}, { ...auth(), responseType: 'blob' }).then(r => r.data),
  getPdfUrl: (id) => axios.get(`${BASE}/${id}/pdf`, auth()).then(r => r.data),
  pushToPriceList: (id) => axios.post(`${BASE}/${id}/push-to-price-list`, {}, auth()).then(r => r.data),
};

export default quoteService;
